<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="留学学员故事姓名"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.avatar.length!==0">
            <va-card
              overlay
              :image='insertData.avatar'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-card title='留学学员故事头像'>
              <va-file-upload
                type='single'
                v-model='insertData.avatarArr'
                @input="uploadAvatarImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.enterprise"
              label="学校/企业名"
              removable
              :messages="message"
              :error="!!error.enterpriseErrors.length"
              :error-messages="error.enterpriseErrors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.enterpriseLogo.length!==0">
            <va-card
              overlay
              :image='insertData.enterpriseLogo'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-card title='学校/企业logo'>
              <va-file-upload
                type='single'
                v-model='insertData.enterpriseLogoArr'
                @input="uploadEnterpriseImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.shortDescription"
              label="简短描述"
              type="textarea"
              maxlength="255"
              @input="shortDescriptionDescInput"
              removable
              :messages="message + shortDescriptionRemnant + remnant"
              :error="!!error.shortDescriptionErrors.length"
              :error-messages="error.shortDescriptionErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.title"
              label="故事标题"
              removable
            />
          </div>

          <div class="flex md12 sm6 xs12">
            <vue-trix
              v-model="insertData.story"
              placeholder="留学学员故事"
              @trix-attachment-add="handleAttachmentChanges"
              :config="captionConfig"
            ></vue-trix>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.school"
              label="学校/企业"
              removable
              :messages="message"
              :error="!!error.schoolErrors.length"
              :error-messages="error.schoolErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.job"
              label="角色"
              removable
              :messages="message"
              :error="!!error.jobErrors.length"
              :error-messages="error.jobErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../../api/upload'
import studentStoryApi from '../../../api/liuxue/studentStory'
import { copyObject } from '../../../utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        avatarArr: [],
        avatar: '',
        enterprise: '',
        enterpriseLogoArr: [],
        enterpriseLogo: '',
        shortDescription: '',
        school: '',
        job: '',
        title: '',
        story: '',
        sortNum: null,
      },
      message: ['Required field '],
      error: {
        nameErrors: [],
        enterpriseErrors: [],
        shortDescriptionErrors: [],
        schoolErrors: [],
        jobErrors: [],
        sortNumErrors: [],
        avatarArrErrors: [],
      },
      title: '新增留学学员故事',
      showId: false,
      shortDescriptionRemnant: 255,
      remnant: '/255',
      submitButtonStatus: true,
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑留学学员故事'
      // 通过id获取详情
      studentStoryApi.getStudentStory(params.id).then(response => {
        copyObject(response, this.insertData)
        this.shortDescriptionRemnant = 255 - this.insertData.shortDescription.length
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.enterpriseErrors.length &&
          !this.error.shortDescriptionErrors.length &&
          !this.error.schoolErrors.length &&
          !this.error.jobErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        avatar: this.insertData.avatar,
        enterprise: this.insertData.enterprise,
        enterpriseLogo: this.insertData.enterpriseLogo,
        shortDescription: this.insertData.shortDescription,
        title: this.insertData.title,
        story: this.insertData.story,
        school: this.insertData.school,
        job: this.insertData.job,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.avatar.length === 0 || this.insertData.enterpriseLogo.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      if (this.insertData.id !== null) {
        data.id = this.insertData.id
        studentStoryApi.updateStudentStory(this.insertData.id, data).then(response => {
          this.$router.push({ name: 'listStudentStory' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        studentStoryApi.saveStudentStory(data).then(response => {
          this.$router.push({ name: 'listStudentStory' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      }
    },
    uploadAvatarImage () {
      if (this.insertData.avatarArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.avatarArr[this.insertData.avatarArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.avatar = response.url
      })
    },
    uploadEnterpriseImage () {
      if (this.insertData.enterpriseLogoArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.enterpriseLogoArr[this.insertData.enterpriseLogoArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.enterpriseLogo = response.url
      })
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.enterpriseErrors = this.insertData.enterprise ? [] : ['enterprise is required']
      this.error.shortDescriptionErrors = this.insertData.shortDescription ? [] : ['shortDescription is required']
      this.error.schoolErrors = this.insertData.school ? [] : ['school is required']
      this.error.jobErrors = this.insertData.job ? [] : ['job is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
      }).catch(error => {
        console.log(error)
      })
    },
    shortDescriptionDescInput () {
      this.shortDescriptionRemnant = 255 - this.insertData.shortDescription.length
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
